import moment from "moment";

export const initialDateState = {
  from: moment()
    .subtract(30, 'days')
    .startOf("day")
    .toDate(),
  to: moment()
    .subtract(1, 'days')
    .endOf("day")
    .toDate(),
  enteredTo: null,
  autoSearched: false
} 

export const initialState = {
  loading_search: false,
  loading_stats: false,
  loading_chart: false,
  error: null,
  date: Object.assign({}, initialDateState),
  searchOptions: {
    date: {
      from: moment(initialDateState.from).format(),
      to: moment(initialDateState.to).format(),
      range: undefined
    },
    status: undefined,
    variable: undefined
  },
  paginationOptions: {
    per_page: 100,
    page: 1
  }
};

export default function SearchReducer(state = initialState, action) {
  switch (action.type) {
    case searchActions.loading_search:
      return {
        ...state,
        loading_search: action.data,
        autoSearched: true,
      };

    case searchActions.loading_stats:
      return {
        ...state,
        loading_stats: action.data,
        autoSearched: true,
      };

    case searchActions.loading_chart:
      return {
        ...state,
        loading_chart: action.data,
        autoSearched: true,
      };

    case searchActions.set_status:
      return {
        ...state,
        searchOptions: {
          ...state.searchOptions,
          status: action.data
        }
      };

    case searchActions.set_date:
      return {
        ...state,
        searchOptions: {
          ...state.searchOptions,
          date: action.data
        }
      };

    case searchActions.set_variable:
      return {
        ...state,
        searchOptions: {
          ...state.searchOptions,
          variable: action.data
        }
      };

    case searchActions.set_per_page:
      return {
        ...state,
        paginationOptions: {
          ...state.paginationOptions,
          per_page: action.data
        }
      };

    case searchActions.set_page:
      return {
        ...state,
        paginationOptions: {
          ...state.paginationOptions,
          page: action.data
        }
      };
    
    case searchActions.search_error:
        return {
            ...state,
            error: action.data
        };
    
    default:
      return state;
  }
}

export const searchActions = {
  // search actions
  set_variable: "search/SET_VARIABLE",
  set_status: "search/SET_STATUS",
  set_date: "search/SET_DATE",

  // pagination actions
  set_per_page: "search/SET_PER_PAGE",
  set_page: "search/SET_PAGE",

  // loading actions
  loading_search: "search/LOADING_SEARCH",
  loading_stats: "search/LOADING_STATS",
  loading_chart: "search/LOADING_CHART",
  
  // error actions
  search_error: "search/ERROR"
};
